<template>
  <div class="user-card c:col-between-center">
    <div
      class="background-banner"
      :style="`background-image: url(${brandInfo.image})`"
    ></div>
    <div class="user-info c:col-start-center">
      <div class="user-avator">
        <img :src="user.caAvatar" alt="" />
      </div>
      <div class="user-name">{{ user.name }}</div>
      <div class="user-position">{{ position }}</div>
    </div>
  </div>
</template>

<script>
import { USER_ROLES } from "@/consts";
import { mapState } from "vuex";

export default {
  props: {
    role: String,
    user: Object,
    store: Object,
  },
  computed: {
    ...mapState(["brandInfo"]),
    position() {
      switch (this.role) {
        case USER_ROLES.CLIENT_AGENT:
          return `${this.user?.storeName || "-"} CA`;

        case USER_ROLES.STORE_MANAGER:
          return `${this.store?.storeName || "-"} 店长`;

        default:
          return "";
      }
    },
  },
};
</script>

<style lang="less" scoped>
.user-card {
  width: 100vw;
  height: 100%;
  background-color: #fff;
  .background-banner {
    width: 100vw;
    height: auto;
    aspect-ratio: 375/212;
    background-image: url(../../assets/mock-images/background-banner.png);
    background-size: cover;
  }
  .user-info {
    flex: 1;

    width: 100vw;
    height: 0;
    transform: translate3d(0, -23/20rem, 0);

    .user-avator {
      width: 46/20rem;
      height: 46/20rem;
      border: solid 1px #fff;
      background-color: #fff;
      border-radius: 50%;
      overflow: hidden;

      img {
        width: 100%;
        height: 100%;
      }
    }
    .user-name {
      height: 18/20rem;
      margin-top: 19/20rem;
      line-height: 18/20rem;
      font-size: 18/20rem;
      font-weight: 500;
      letter-spacing: 0.41/20rem;
      color: #000;
    }

    .user-position {
      height: 11/20rem;
      margin-top: 6/20rem;
      line-height: 11/20rem;
      font-size: 11/20rem;
      font-weight: 400;
      letter-spacing: 0.38/20rem;
      color: #909090;
    }
  }
}
</style>
